module.exports = __webpack_public_path__ + "img/Frame-30.f8e5651e.svg";